import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import Utils from '../../../utils/Utils';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class GetUserInfoTask extends AbstractRequestTask {
    constructor(email = '') {
        super();
        this.email = email;
    }

    getHeaders() {      
      return {
        'Content-Type': 'application/x-www-form-urlencoded'
      };
    }

   getParams() {  
    const params = super.getParams();
    const email = this.email;
    delete params.HKS;
    delete params.device_name;
    delete params.region; 
    delete params.format;
    delete params.user_id;
    delete params.user_token
    return Object.assign({}, params, { email });
    }

    getMethod() {
        return 'GET';
    }

    getUrl() {
      const http = "https://";
      const url = Launcher.get("akamai_mfwk");
      return `${http}${url}/services/user/getuserinfo?${Utils.buildQueryParams(this.getParams())}`;
    }

    success(data, b) {
        this.resolve(data);
    }
    
    getShowErrorModal(){
      return ENABLE_MODAL_RETRIES;
    }

    isValid() {
        return true;
    }

}

export default GetUserInfoTask;


// WEBPACK FOOTER //
// ./src/requests/tasks/user/GetUserInfoTask.js